import {BrowserRouter , Route} from 'react-router-dom';
import Navbar from '../src/component/Navbar'
import Home from '../src/component/Home.js'
import CourseDetails from '../src/component/CourseDetails.js'
import UpComing from '../src/component/UpComing.js'
import SignUp from '../src/component/SignUp.js'
import SignIn from '../src/component/SignIn.js'
import ScrollTop from '../src/component/ScrollTop.js';
import Footer from '../src/component/Footer.js'
import '../src/styles/MediaQuery.css';


function App() {
  return (
    <>
      <BrowserRouter>
        <Navbar/>
        <Route exact path="/" component={Home}/>
        <Route path="/CourseDetails" component={CourseDetails}/>
        <Route path="/UpComing" component={UpComing}/>
        <Route path="/SignIn" component={SignIn}/>
        <Route path="/SignUp" component={SignUp}/>
      </BrowserRouter>
      <ScrollTop/>
      <Footer/>
    </>
  )
}

export default App;
